import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Spinner,
} from "@fluentui/react-components";
import React, { useEffect, useRef } from "react";
import ASCButton from "../Button";

function DeletePopup(props: any) {
  const noButtonRef = useRef<HTMLButtonElement>(null);

  // Default focus must land on "No" — a keyboard user pressing Enter
  // without deliberately tabbing to a button must not trigger the delete.
  useEffect(() => {
    if (props.deletePopup) {
      noButtonRef.current?.focus();
    }
  }, [props.deletePopup]);

  return (
    <Dialog open={props.deletePopup}>
      <DialogSurface>
        <DialogBody>
          <h3>Do you want to delete?</h3>
          <DialogActions>
            <ASCButton
              ref={noButtonRef}
              shape="rounded"
              className="asc-button-primary"
              appearance="primary"
              disabled={props.deleteApiProcessing}
              onClick={() => props.setDeletePopup(false)}
              label="No"
            />
            <ASCButton
              shape="rounded"
              appearance="secondary"
              disabled={props.deleteApiProcessing}
              onClick={() => {
                props.deleteData();
              }}
              icon={props.deleteApiProcessing ? <Spinner size="tiny" /> : null}
              label={props.deleteApiProcessing ? "Processing..." : "Yes"}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default DeletePopup;
